// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g-icon{display:inline-block;width:1em;height:1em;fill:currentColor;overflow:hidden;font-size:24px}.g-icon--small{font-size:12px}.g-icon--medium{font-size:18px}.g-icon--big{font-size:22px}.g-icon--large{font-size:32px}.g-icon--huge{font-size:42px}.g-icon--gigantic{font-size:64px}.g-icon--spin{animation:icon-rotation 1s linear infinite}@keyframes icon-rotation{to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
